import * as React from 'react';
var headerCellClassName = function (sort, field, locked) {
    var result = "" + (locked ? 'k-grid-header-sticky' : '');
    if (sort.some(function (descriptor) { return descriptor.field === field; })) {
        result += ' k-sorted';
    }
    return result;
};
/**
 * @hidden
 */
export var FilterRow = function (props) {
    var columns = props.columns, filter = props.filter, filterChange = props.filterChange, _a = props.sort, sort = _a === void 0 ? [] : _a;
    return (React.createElement("tr", { className: "k-filter-row" }, columns.map(function (column, index) {
        var style = (column.locked !== undefined) ? {
            left: column.left,
            right: column.right,
            borderRightWidth: column.rightBorder ? '1px' : ''
        } : {};
        return (React.createElement("th", { style: style, key: index, className: headerCellClassName(sort, column.field, column.locked) }, column.filter && (React.createElement(column.filter, { field: column.field, filter: filter, onFilterChange: filterChange }))));
    })));
};
//# sourceMappingURL=FilterRow.js.map